module.exports = __webpack_public_path__ + "img/SparKlean Laundry.b2c11b08.svg";